module.exports = __webpack_public_path__ + "img/princewill.6f301084.png";